import * as React from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { CodetableItemContentProps } from 'app/area/codetable/list/list-items/types';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { DisabledTag } from 'app/area/codetable/common/disabled-tag/disabled-tag';
import { renderLine } from 'app/area/shared/codetable/list-item/list-item-lines';
import { CodeActionType } from 'app/area/codetable/item/types';

import styles from './uom-codetable-item-content.scss';

export const UomCodetableItemContent = ({ codeItem, isHierarchyMode, hierarchyMetadata,
  refetching, treeDepthLevel, breadcrumbs, translation, deletingCodeItem }: Partial<CodetableItemContentProps>) => {

  const contentClass = !isHierarchyMode ? styles.content : styles.hierarchyContent;

  return (
    <Link
      to={routeConstants.codetableAdministrationCodeFor(breadcrumbs, codeItem.id, CodeActionType.Edit)}
      className={`${styles.container} ${deletingCodeItem ? styles.disabled : ''}`}>
      {isHierarchyMode
        ? renderLine(hierarchyMetadata, treeDepthLevel)
        : null}
      <div className={contentClass}>
        <div className={styles.leftSide}>
          <div className={styles.leftSideColumn}>
            {codeItem?.category ?
              <div className={styles.defaultColumn}>
                {codeItem.category.description} {(refetching || deletingCodeItem) && <CodetableItemLoader />}
              </div>
              : null}
          </div>
          <div className={styles.leftSideColumn}>
            {codeItem.description ?
              <div className={styles.defaultColumn}>
                {codeItem.description} {(refetching || deletingCodeItem) && <CodetableItemLoader />}
              </div>
              : null}
          </div>
        </div>
        <div className={styles.rightSide}>
          <DisabledTag codeItem={codeItem} translation={translation} />
        </div>
      </div>
    </Link>
  );
};
